const messages = {
  "seasons": {
    "all": "All season",
    "summer": "Zomer",
    "winter": "Winter",
    "general": "Algemeen"
  },
  "offer": "Wij breiden ons trainingsaanbod regelmatig uit. We informeren u hierover in uw BRIDGESTONE <span class='text-danger'>PLUS</span> inbox.",
  "summary": {
    "congratulations": "Gefeliciteerd, u hebt de producttraining {name} met succes afgerond.",
    "participation": "U ontvangt uw certificaat per e-mail of u kunt het hier direct als PDF downloaden:",
    "certificate": "U ontvangt uw certificaat per e-mail of u kunt het hier direct als PDF downloaden:",
    "send": "Certificaat downloaden"
  },
  "online": {
    "title": "Online training",
    "desc": "Vergroot uw kennis van de Bridgestone-producten. Als u de korte test met succes afrondt, ontvangt u 25 extra punten en een certificaat van deelname.",
    "content": "Ontdek onze online trainingen en neem direct deel",
    "categories": {
      "title": "Online Training",
      "description": "Stay ahead with knowledge: Secure exclusive expertise for you and your team with our training offerings. Whether it's our online training sessions, which you can participate in directly on the platform, our courses and practical seminars at the Bridgestone Training Center, or even external training sessions whose costs you can reduce with your premium points.",
      "general": {
        "title": "General",
        "subtitle": "Online Training: General",
        "description": "Discover the latest technologies, important developments in the tire industry, tips for your sales pitch, and more.",
        "subdesription": "Secure expert knowledge and, upon successful completion of the respective training tests, your personal certificate of participation as well as a one-time bonus of 40 extra points for the premium club."
      },
      "product": {
        "title": "Products",
        "subtitle": "Online Training: Products",
        "description": "Deepen your Bridgestone and Firestone product expertise for successful sales with our compact training videos.",
        "subdesription": "Secure expert knowledge and, upon successful completion of the respective training tests, your personal certificate of participation as well as a one-time bonus of 40 extra points for the premium club."
      }
    }
  },
  "lectures": {
    "title": "Bridgestone-opleiding",
    "desc": "Breid uw vakkennis verder uit en boek onze intensieve trainingen, gehouden op uw eigen locatie, voor uzelf en of uw team. U kunt uw spaarpunten gebruiken voor de trainingen en de kosten geheel of gedeeltelijk verrekenen met uw punten.",
    "content": "Ontdek nu onze actuele trainingen en vraag een boeking aan:"
  },
  "singleLecture": {
    "registerForm": {
      "title": "Inhoud van de opleiding",
      "inquiry": "Navraag",
      "interested": "Ik ben geïnteresseerd in de opleiding",
      "participantsNr": "Aantal deelnemers",
      "pointsFromBalance": "Ik wil graag punten uit mijn puntensaldo gebruiken.",
      "reduction": "Dit komt overeen met een besparing op de trainingskosten van {points} euro.",
      "request": "Verzend verzoek",
      "notEnoughPoints": "U heeft onvoldoende marketing punten om dit item toe te voegen aan uw winkelmand."
    },
    "success": {
      "thanks": "Bedankt",
      "title": "Uw aanvraag is verzonden naar het trainingsteam.",
      "feedbackTime": "U ontvangt binnen 14 dagen feedback om alle details te verduidelijken.",
      "points": "De gebruikte beloningspunten ter waarde van<br /><strong>{points}</strong> punten zijn afgetrokken van uw<br />puntenaccount.",
      "refund": "Indien de training niet doorgaat, worden de punten uiteraard weer aan u bijgeschreven.",
      "queries": "Als u vragen heeft, kunt u contact opnemen met:"
    },
    "index": {
      "costs": "Kosten en deelname-informatie",
      "duration": "Duur: {duration}",
      "cost": "Kosten {cost}: {price} euro ({points} points)",
      "participantsNr": "Aantal deelnemers: min. {min} -max. {max} mensen"
    }
  },
  "index": {
    "title": "Training",
    "desc": "Verzeker u en uw team van exclusieve vakkennis met ons trainingsaanbod. We bieden online trainingen waaraan u direct kunt deelnemen en waarmee u extra punten kunt verdien, of we komen naar u toe voor een product- en/of technische training.",
    "online": {
      "title": "Online training",
      "desc": "Ontdek online training en krijg inzicht in de Bridgestone-productwereld!",
      "short_desc": "Volg de online trainingen en ontdek de Bridgestone-producten."
    },
    "lectures": {
      "title": "Training op locatie",
      "desc": "Hoogwaardige trainingen op locatie."
    },
    "external": {
      "title": "Externe training",
      "desc": "Gebruik spaarpunten voor aanbiedingen van derden en verlaag de kosten."
    }
  },
  "single": {
    "done": "Training afgerond.",
    "doneDownloadCertificate": "Training afgerond. Download certificaat."
  },
  "certificate": {
    "header": "CERTIFICATE",
    "atCourse": "has successfully participated in the",
    "takePart": "course.",
    "contains": "COMPONENTS OF THE COURSE",
    "country": "Netherland"
  }
};

export default {
  messages,
};
